import { usePrimarySwatchDomain } from "@/configurator/domain/hooks/useViewerDomain";

export type TwoDRendererComponent = {
  /** Fill the placeholder paints, taken from the current swatch selection. */
  primaryColor: string;
};

export function useTwoDRendererComponent(): TwoDRendererComponent {
  return { primaryColor: usePrimarySwatchDomain() };
}
